/**
 * GET texte brut (HTML, etc.) — hors `FetchData` : la réponse n’est pas du JSON
 * et ne doit pas forcément reprendre les en-têtes API (ex. prévisualisation .eml → .html).
 */
export function fetchTextResource(url) {
  return fetch(url).then((response) => {
    if (!response.ok) {
      throw new Error(String(response.status));
    }
    return response.text();
  });
}
